import { supabase } from './supabase';
import { RecurringCalendarEvent } from '../types/models';

export enum SubscribedSourceType {
  KOREAN_HOLIDAYS = 'KOREAN_HOLIDAYS', //대한민국의 공휴일 
  PAYDAY = 'PAYDAY', //월급날
  FOUNDATION = 'FOUNDATION', //케이스마텍 창립기념일 
}

/**
 * Supabase의 calendar_events 테이블에서 구독 캘린더 이벤트를 조회합니다.
 * 기간 필터는 선택이며, 미지정 시 최근 1년 전부터 2년 후까지 조회합니다.
 */
export const fetchSubscribedCalendarEvents = async (
  sourceTypes: SubscribedSourceType[],
  from?: string,
  to?: string
): Promise<RecurringCalendarEvent[]> => {
  // 기본 기간: 올해 1월 1일 ~ 3년 뒤 12월 31일
  const now = new Date();
  const defaultFrom = new Date(now.getFullYear(), 0, 1);                // YYYY-01-01
  const defaultTo   = new Date(now.getFullYear() + 3, 11, 31);          // (올해+3)-12-31

  const fromStr = from ?? defaultFrom.toISOString().slice(0, 10);
  const toStr = to ?? defaultTo.toISOString().slice(0, 10);

  const { data, error } = await supabase
    .from('calendar_events')
    .select('title,start_date,end_date,all_day,is_recurring,rrule,source_type')
    .in('source_type', sourceTypes)
    .gte('start_date', fromStr)
    .lte('start_date', toStr)
    .order('start_date', { ascending: true });

  if (error) {
    console.error('Failed to fetch subscribed calendar events from Supabase:', error);
    throw error;
  }

  const events: RecurringCalendarEvent[] = (data ?? []).map((row: any) => ({
    title: row.title,
    start: row.start_date, // YYYY-MM-DD
    end: row.end_date,     // YYYY-MM-DD
    allDay: row.all_day ?? true,
    isRecurring: row.is_recurring ?? false,
    recurrenceRule: row.rrule ?? '',
  }));

  return events;
};

export const fetchKoreanHolidaysFromSupabase = async (): Promise<RecurringCalendarEvent[]> => {
  return fetchSubscribedCalendarEvents([SubscribedSourceType.KOREAN_HOLIDAYS]);
};

export const fetchPayDaysFromSupabase = async (): Promise<RecurringCalendarEvent[]> => {
  return fetchSubscribedCalendarEvents([SubscribedSourceType.PAYDAY]);
};

export const fetchFoundationAnniversaryFromSupabase = async (): Promise<RecurringCalendarEvent[]> => {
  return fetchSubscribedCalendarEvents([SubscribedSourceType.FOUNDATION]);
};

